import React, { Component } from 'react';
import CSSModules from 'helpers/CSSModulesUtil';
import styles from './styles.scss';
import { compose } from 'recompose';
import {
    Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'


class ErrorTable extends Component {
    render() {

        const { errors } = this.props

        return (
            <React.Fragment>
                {errors.length >= 100 && <div className={styles.errorsLengthMsg}>Note: too many errors detected. Only the first 500 errors are shown.</div>}
                <div className={styles.tableParent}>
                    <Table selectable={false}>
                        <TableHead key={`head`}>
                            <TableCell key={`errorType`}>Description</TableCell>
                        </TableHead>
                        {
                            errors.map((error, idx) => {
                                return (
                                    <TableRow key={`${error}${idx}`}>
                                        <TableCell><code className={styles.red}>{error.info}</code></TableCell>
                                    </TableRow>)
                            })
                        }
                    </Table>
                </div>
            </React.Fragment>
        )
    }
}

const withStyles = CSSModules(styles);
const enhance = compose(withStyles);
export default enhance(ErrorTable);
